import React, { useState } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

function TextEditor() {
    const [value, setValue] = useState('');
    const [htmlOutput, setHtmlOutput] = useState('');

    // Define the formats we want to support
    const formats = [
        'header',
        'bold', 'italic', 'underline', 'strike',
        'list', 'bullet',
        'link', 'image'
    ];

    // Define the editor modules/toolbar
    const modules = {
        toolbar: [
            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
            ['bold', 'italic', 'underline', 'strike'],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            ['link', 'image'],
            ['clean']
        ]
    };

    // Update content and show HTML output
    const handleChange = (content) => {
        setValue(content);
        setHtmlOutput(content);
    };

    return (
        <div className="text-editor-container">
            <h2>React Quill Editor</h2>

            <div className="editor">
                <ReactQuill
                    theme="snow"
                    value={value}
                    onChange={handleChange}
                    modules={modules}
                    formats={formats}
                />
            </div>

            <div className="output-section">
                <h3>HTML Output:</h3>
                <pre className="html-output">{htmlOutput}</pre>
            </div>

            <div className="rendered-output">
                <h3>Rendered Output:</h3>
                <div dangerouslySetInnerHTML={{ __html: value }} />
            </div>

            <style jsx>{`
        .text-editor-container {
          max-width: 800px;
          margin: 0 auto;
          padding: 20px;
        }
        .editor {
          margin-bottom: 20px;
          border: 1px solid #ccc;
          border-radius: 4px;
        }
        .output-section {
          margin-top: 30px;
          background-color: #f5f5f5;
          padding: 15px;
          border-radius: 4px;
        }
        .html-output {
          background-color: #f0f0f0;
          padding: 10px;
          border-radius: 4px;
          overflow-x: auto;
        }
        .rendered-output {
          margin-top: 20px;
          padding: 15px;
          border: 1px solid #ddd;
          border-radius: 4px;
        }
      `}</style>
        </div>
    );
}

export default TextEditor;